import DOMPurify from 'dompurify';

export type SanitizeHtmlProps = {
  html: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const SanitizeHtml = ({ html, ...props }: SanitizeHtmlProps) => {
  const sanitizedHtml = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
